import dayjs from 'dayjs';

export const normalizeDatepickerValue = (from?: string | null, to?: string | null, separator = '.') => {
    const start = from ? dayjs(from).utc().format(`DD${separator}MM${separator}YYYY`) : '';
    const end = to ? dayjs(to).utc().format(`DD${separator}MM${separator}YYYY`) : '';

    if (start || end) {
        return start + ' - ' + end;
    }

    return '';
};
